import instance from '../../axios';

export const getSummary = async (from, to, id) => {
    const response = await instance.get('summary?from=' + from + '&to=' + to + `${id ? `&boothId=${id}` : ``}`)
    return response.data
}

export const getAverageSummary = async (from, to, id) => {
    const response = await instance.get('summary/average?from=' + from + '&to=' + to + `${id ? `&boothId=${id}` : ``}`)
    return response.data
}
